import React from 'react'

import { SchemaCustomfield } from '@/__generated/es-api'
import { Form } from '@/app/component/form'
import { ActionsContainer, FlexFormContainer } from '@/app/component/form/common'
import SubmitButton from '@/app/component/form/submit-button'
import { useUpdateCustomField } from '@/app/module/custom-fields/hooks/use-update-custom-field'

import { getUpdateCFDefaultValues, UpdateCustomFieldFormValues, updateCFFields, updateCFSchema } from './specs'

type Props = {
  customField: SchemaCustomfield
  onExit: () => void
}

const UpdateCustomFieldForm: React.FC<Props> = ({ customField, onExit }) => {
  const [updateCustomField, { isLoading }] = useUpdateCustomField()

  const handleSubmit = React.useCallback(
    async (data: UpdateCustomFieldFormValues) => {
      const result = await updateCustomField(customField.id, data.name)
      if (result) {
        onExit()
      }
    },
    [updateCustomField, customField.id, onExit],
  )

  const defaultValues = React.useMemo(() => getUpdateCFDefaultValues(customField.name), [customField.name])

  return (
    <FlexFormContainer>
      <Form
        defaultValues={defaultValues}
        fields={updateCFFields}
        schema={updateCFSchema}
        onSubmit={handleSubmit}
        renderActions={({ isDirty }) => (
          <ActionsContainer>
            <SubmitButton isDirty={isDirty} isSubmitting={isLoading}>
              Update
            </SubmitButton>
          </ActionsContainer>
        )}
      />
    </FlexFormContainer>
  )
}

export default UpdateCustomFieldForm
